/**
 * 项目管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const projectRoute = [
  {
    // component: Layout,
    component: lazyLoad,

    path: "/projectManage",
    meta: {
      title: "项目管理",
      icon: "icon-project-manage",
    },
    children: [
      //项目列表
      {
        path: "/project/list",
        name: "ProjectList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/projectList"
          ),
        meta: {
          title: "项目列表",
          keepAlive: true,
        },
      },
      // 新建项目
      {
        path: "/project/create",
        name: "ProjectCreate",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/projectCreate"
          ),
        meta: {
          title: "新增项目",
          relatedPermission: "项目列表",
          parentName: "ProjectList",
        },
      },

      //医院列表
      {
        path: "/project/hospital/list",
        name: "ProjectHospitalList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/hospitalList"
          ),
        meta: {
          title: "医院列表",
          keepAlive: true,
        },
      },

      //药房列表
      {
        path: "/project/pharmacy/list",
        name: "ProjectPharmacyList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/pharmacyList"
          ),
        meta: {
          title: "药房列表",
          keepAlive: true,
        },
      },

      //新增药房
      {
        path: "/project/pharmacy/create",
        name: "ProjectPharmacyCreate",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/pharmacyList/create.vue"
          ),
        meta: {
          type: "create",
          title: "新增药房",
          relatedPermission: "药房列表",
        },
      },

      //编辑药房
      {
        path: "/project/pharmacy/edit",
        name: "ProjectPharmacyEdit",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/pharmacyList/create.vue"
          ),
        meta: {
          type: "edit",
          title: "编辑药房",
          relatedPermission: "药房列表",
        },
      },

      //拜访统计
      {
        path: "/project/visitDetails/list",
        name: "ProjectVisitDetailsList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/visitDetails"
          ),
        meta: {
          title: "拜访统计",
          keepAlive: true,
        },
      },

      //专员管理
      {
        path: "/project/management/list",
        name: "ProjectManagement",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/management/index.vue"
          ),
        meta: {
          title: "专员管理",
        },
      },
      //所有项目
      {
        path: "/projectManage/allList",
        name: "ProjectAllList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/projectAll/ProjectList.vue"
          ),
        meta: {
          title: "所有项目",
          keepAlive: true,
        },
      },

      //所有机构
      {
        path: "/project/institutionList",
        name: "InstitutionAllList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/institutionAll/InstitutionList.vue"
          ),
        meta: {
          title: "所有机构",
          keepAlive: true,
        },
      },

      //商品管理
      {
        path: "/project/goodsManage/list",
        name: "ProjectGoodsManage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/goodsManage/index.vue"
          ),
        meta: {
          title: "商品管理",
          keepAlive: true,
        },
      },
      //新增商品
      {
        path: "/project/goodsManage/createGoods",
        name: "ProjectCreateGoods",
        hidden: true,
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/projectManage/goodsManage/createGoods.vue"
          ),
        meta: {
          title: "新增商品",
          relatedPermission: "商品管理",
        },
      },
    ],
  },
];
export default projectRoute;
